import * as React from 'react';
import { Icons, Tooltip, TooltipIcon } from 'src/components';
import { IGridElement, IRowValidation } from '../types';
import { hasError, isValid } from './services/validationMessages';

interface ISidebarProps {
  grid: IGridElement[][];
  validation: IRowValidation[];
  validateAll: () => void;
  deleteRow: (i: number) => () => void;
  copyRow: (i: number) => () => void;
  validateRow: (i: number) => () => void;
}

export const Sidebar = (props: ISidebarProps) => (
  <div className="w-48 pl-2 pt-12">
    <div className="border-b border-white">
      <button
        onClick={props.validateAll}
        className="block w-full h-8 p-2 bg-grey hover:bg-grey-dark rounded"
      >
        Validate all
      </button>
    </div>

    {props.grid.map((_, i) => {
      const { validating, messages } = props.validation[i];
      const isRowValid = isValid(messages);
      const rowHasError = hasError(messages);

      return (
        <div key={i} className="flex items-center border-b border-white">
          {messages.length > 0 ? (
            <TooltipIcon
              className="text-xs"
              positionY="top"
              type={isRowValid ? 'success' : rowHasError ? 'error' : 'warning'}
              width={isRowValid ? 'w-16' : 'w-48'}
              text={messages[0]}
            />
          ) : (
            <TooltipIcon
              className="text-xs"
              positionY="top"
              type={validating ? 'loading' : 'info'}
              width="w-32"
              text={validating ? 'Validating' : 'Not validated yet'}
              isLoading={validating}
            />
          )}
          <button
            onClick={props.validateRow(i)}
            className={`flex-1 block h-8 p-2 mx-2 hover:bg-grey-dark rounded ${
              validating ? 'loader bg-grey-dark' : 'bg-grey'
            }`}
            disabled={validating}
          >
            Validate
          </button>

          <button onClick={props.copyRow(i)} className="mr-2">
            <Tooltip
              text="Copy row"
              position="top"
              side="right"
              className="text-xs"
            >
              <Icons.Copy />
            </Tooltip>
          </button>
          <button onClick={props.deleteRow(i)}>
            <Tooltip
              text="Delete row"
              position="top"
              side="right"
              className="text-xs"
            >
              <Icons.Trash className="w-4" />
            </Tooltip>
          </button>
        </div>
      );
    })}
  </div>
);



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/Sidebar.tsx